import React from "react";
import MaterialIcon from "components/common/MaterialIcon";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Card, Button } from "antd";
import Config from "config/routes";
import uploadlogo from "assets/images/bg.png";
import feeds from "assets/images/feed.png";

@withRouter
@autobind
/**
 *
 */
export default class NotFound extends React.PureComponent {
  static propTypes = {
    match: PropTypes.object,
    location: PropTypes.object,
    history: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      pathUrl: null,
      description: null,
    };
  }
  /**
   *
   * @return {XML}
   */
  renderContent() {
    const { history } = this.props;
    console.log("#45345", location.pathname);

    const x = Config.routes.home.filter((el) => {
      return location.pathname.includes(el.path);
    });

    console.log("xxxxxx", x[0].path);
    const url = location.pathname.includes("guardian");
    console.log("453453", x);

    switch (x[0].path) {
      case "guardian":
      case "feed":
      case "bulletin":
      case "salary":
      case "payroll":
      case "map":
        this.setState({ pathUrl: x[0].name, description: x[0].description });
        return (
          <div
            style={{
              textAlign: "center",
              overflow: "hidden",
              width: "60%",
              textAlign: "justify",
              color: "white",
              lineHeight: "2",
            }}
          >
            {typeof this.state.description === "string"
              ? this.state.description
              : JSON.stringify(this.state.description)}
          </div>
        );
      case "basic":
      case "attendance": {
        const { pathname } = this.props.location;

        // مسیر صحیح را از لیست مسیرها پیدا می‌کنیم
        const matchedRoute = x[0].routes.find((route) =>
          pathname.includes(route.path)
        );

        if (matchedRoute) {
          console.log("Matched Route:", matchedRoute);

          return (
            <div
              style={{
                textAlign: "justify",
                overflow: "hidden",
                width: "60%",
                color: "white",
                lineHeight: "2",
              }}
            >
              {typeof matchedRoute.description === "string"
                ? matchedRoute.description
                : JSON.stringify(matchedRoute.description)}
            </div>
          );
        }

        return <div>جهت اطلاع بیشتر با شماره تلفن 41392000 و داخلی 3 تماس حاصل نمایید.</div>; // اگر هیچ مسیری تطابق نداشت، چیزی برنگردان
      }

      default:
        <div>ss</div>;
        break;
    }
  }
  render() {
    const { history } = this.props;
    console.log("ConfiConfigg", Config.routes.home);

    return (
      <div
        className="wrapper"
        style={{
          textAlign: "center",
          background: "rgb(236,236,236)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div style={{ position: "relative", width: "80%" }}>
          <div
            style={{
              position: "absolute",
              right: "4vw",
              top: "4vw",
              fontSize: "1vw",
            }}
          >
            {this.renderContent()}
          </div>
          <Button
            type="danger"
            style={{
              position: "absolute",
              right: "4vw",
              bottom: "4vw",
              fontSize: "1vw",
              padding: "16px",
              display: "flex",
              alignItems: "center",
            }}
            onClick={() => {
              // submit(), this.onReloadSalary();
            }}
          >
            مشاهده فیلم
          </Button>{" "}
          <img src={uploadlogo} width={"100%"} />
          {/* <img
            src={feeds}
            width={"30%"}
            style={{
              position: "absolute",
              left: "4vw",
              bottom: "4vw",
              fontSize: "1vw",
              padding: "16px",
              display: "flex",
              alignItems: "center",
            }}
          /> */}
        </div>
        {/* <Card className="errorPage">
          <MaterialIcon
            name="lock"
            size="medium"
            style={{
              color: "#ff9800",
            }}
          />

          <h3>ماژول {this.state.pathUrl}</h3>
          <h2
            style={{
              marginTop: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >


            <div>{this.renderContent()}</div>
            <div
              style={{
                height: "100%",
                padding: "2rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <p>{app.translate("routes.405")}</p>
              <h3 style={{ lineHeight: 3.5 }}>
                ماژول {this.state.description}
              </h3>
            </div>
          </h2>

          <Button
            onClick={() => history.push("/")}
            style={{
              marginTop: 24,
            }}
          >
            {app.translate("main.Back")}
          </Button>
        </Card> */}
      </div>
    );
  }
}
